import { addDays } from "date-fns";

function formatDate(date) {
  let day = date.getDate();
  let month = date.getMonth() + 1; // starts from 0
  const year = date.getFullYear();

  // 01, 02, ..., 09
  if (day < 10) day = "0" + day;
  if (month < 10) month = "0" + month;

  return `${day}/${month}/${year}`;
}

export function getDateRange(actual_date) {
  const start = new Date(actual_date);
  const end = addDays(start, 1);

  return [formatDate(start), formatDate(end)];
}

/**
 * Time input ex 13:00:00
 * Time output ex 13:00 (01:00 PM)
 * @param {string} timeString
 * @param {string} language
 */
export function formatTime(timeString, language) {
  // internal function to pad with zeros
  const zeroPad = (num, places) => String(num).padStart(places, "0");

  let parts = timeString.split(":");
  let hourInt = parseInt(parts[0]);
  let ampm = language === "ar" ? "ص" : "AM";

  if (hourInt >= 12) {
    ampm = language === "ar" ? "م" : "PM";
    hourInt = hourInt > 12 ? hourInt - 12 : hourInt;
  } else if (hourInt === 0) {
    hourInt = 12;
  }

  let hour = zeroPad(hourInt, 2);

  return `${parts[0]}:${parts[1]} (${hour}:${parts[1]} ${ampm})`;
}
